import type { ScenarioRow } from '../Dashboard';
import { MOCK_SCENARIOS } from './scenarios';

let scenarios = [...MOCK_SCENARIOS];

const MOCK_LATENCY_MS = 250;
const latency = () =>
  new Promise((resolve) => {
    setTimeout(resolve, MOCK_LATENCY_MS);
  });

const today = () =>
  new Date().toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });

// In-memory stand-in for the Partner API scenario list endpoint.
export const mockGetScenarios = async (): Promise<ScenarioRow[]> => {
  await latency();
  return [...scenarios];
};

// In-memory stand-in for the Partner API duplicate endpoint.
export const mockDuplicateScenario = async (id: string): Promise<void> => {
  const source = scenarios.find((scenario) => scenario.id === id);
  if (!source) throw new Error(`Scenario ${id} not found`);
  const nextId = String(
    Math.max(0, ...scenarios.map((scenario) => Number(scenario.id))) + 1,
  );
  const date = today();
  scenarios = [
    ...scenarios,
    {
      ...source,
      id: nextId,
      loanId: `${source.loanId.slice(0, -4)}${nextId.padStart(4, '0')}`,
      name: `${source.name} - Copy`,
      createdDate: date,
      modifiedDate: date,
    },
  ];
};

// In-memory stand-in for the Partner API delete endpoint.
export const mockDeleteScenario = async (id: string): Promise<void> => {
  scenarios = scenarios.filter((scenario) => scenario.id !== id);
};
